var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 28c5.523 0 10-4.477 10-10S23.523 8 18 8 8 12.477 8 18c0 1.185.206 2.323.585 3.378L7 25l3.239-.694A9.98 9.98 0 0018 28zm5-13H13l-1 1 1 1h10l1-1-1-1zm-10 4h6l1 1-1 1h-6l-1-1 1-1z",
    fill: "#9A9CAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 30c6.075 0 11-4.925 11-11 0-1.34-.24-2.623-.678-3.81A9.965 9.965 0 0132 22a9.981 9.981 0 01-.585 3.378L33 29l-3.239-.694A9.98 9.98 0 0122 32a9.965 9.965 0 01-6.812-2.678C16.377 29.761 17.66 30 19 30z",
    fill: "#9A9CAC"
  })));
}

export default SvgSupportIcon;